import { z } from "zod";
export const GatewaysResponseSchema = z.record(z.string(), z.object({ name: z.string(), host: z.string() }));
export const MediasoupResponseSchema = z.array(z.object({ protooHost: z.string(), protooPort: z.number() }));
